var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{attrs:{"size":_vm.size,"value":_vm.value,"readonly":"readonly"}})
}
var staticRenderFns = []

export { render, staticRenderFns }